import { Type } from 'class-transformer';
import { DocumentCategoryResultDto } from '../../shared-document-module/_models/documents-editor/document-category-result-dto';
import { DocumentSubCategoryResultDto } from '../../shared-document-module/_models/documents-editor/document-subcategory-result-dto';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';

export class UploadEmailDocumentEditorResultDto {
    customerId: string;
    ownerName: string;
    communityId: number;
    community: string;

    @Type(() => DocumentCategoryResultDto)
    categories: Array<DocumentCategoryResultDto>;

    @Type(() => DocumentSubCategoryResultDto)
    subCategories: Array<DocumentSubCategoryResultDto>;

    @Type(() => KeyValueResultDto)
    fileTypes: Array<KeyValueResultDto>;

    attachmentFileNames: Array<string>;
}
